/**
 * Carry a GG+ pass through signup and login.
 * The public URL already contains the token. Signup is several screens, so the
 * token and the "they already tapped Claim" flag also live in sessionStorage.
 */

const TOKEN_KEY = 'gg_plus_pass_token';
const PENDING_KEY = 'gg_plus_pass_claim_pending';

export const PASS_CLAIM_LINE = "Continue to claim your GG+ Pass. No credit card needed.";

// check if the path is a pass path
export function isPassPath(path) {
  if (!path || typeof path !== 'string') return false;
  const pathname = path.split('?')[0];
  return pathname === '/plus/pass' || pathname.startsWith('/plus/pass/');
}

// remember the pass token
export function rememberPassToken(token) {
  if (!token) return;
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
  } catch (e) {
    // ignore storage errors
  }
}

/** They tapped Claim while logged out. Redeem when they land back on this link. */
export function rememberClaimPending(token) {
  if (!token) return;
  rememberPassToken(token);
  try {
    sessionStorage.setItem(PENDING_KEY, token);
  } catch (e) {
    // ignore storage errors
  }
}

export function peekClaimPending() {
  try {
    return sessionStorage.getItem(PENDING_KEY);
  } catch (e) {
    return null;
  }
}

export function clearClaimPending() {
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch (e) {
    // ignore storage errors
  }
}
